import Vue from 'vue'
import { formatCurrency } from '~/assets/util/helpers'

export default ({ store }) => {
	Vue.prototype.$filters = {
		formatCurrency: (price) => {
			const currency = store.state.products.currency

			return formatCurrency(price, currency)
		},

		formatCurrencyDecimal: (price, decimals = 2) => {
			const currency = store.state.products.currency

			return formatCurrency(price, currency, decimals)
		}
	}
}
